import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { store } from "../../../_core/core.Store";
import { action_setCurrentTicket } from "../../../_core/store/actions/actions.Game";

import "./TicketSelector.styles.css";

const TicketSelector = (_props: any) => {
  const [currentTicket, setCurrentTicket] = useState<number>(-1);
  const scroll = useRef(null);

  useEffect(() => {
    if (!_props.GAMEPLAY.currentTicket) {
      setCurrentTicket(-1);
    } else {
      let _index = _props.GAMEPLAY.tickets.findIndex((el: any) => {
        return el.ticketNumber === _props.GAMEPLAY.currentTicket.ticketNumber;
      });
      if (_index !== currentTicket) {
        setCurrentTicket(_index);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_props.GAMEPLAY.currentTicket]);

  if (!_props.GAMEPLAY.tickets.length) return null;

  const totalTickets = _props.GAMEPLAY.tickets.length;
  const tickets = _props.GAMEPLAY.tickets;

  const nextTicket = () => {
    if (currentTicket + 1 > totalTickets) return false;
    setCurrentTicket((value) => value + 1);

    action_setCurrentTicket(tickets[currentTicket + 1])(store.dispatch);
  };

  const previousTicket = () => {
    if (currentTicket < 0) return false;

    setCurrentTicket((value) => value - 1);

    action_setCurrentTicket(tickets[currentTicket - 1])(store.dispatch);
    //@ts-ignore
    scroll.current.style.left = -(currentTicket - 1) * 25 + "px";
  };

  return (
    <div id="scroll-div" className="ticketSelector_wrapper">
      <button
        className="ticketSelector_btn previous"
        disabled={currentTicket < 0}
        onClick={() => previousTicket()}
      ></button>
      <div className="ticketSelector_label">
        <div ref={scroll}>
          {tickets.map((el: any, index: number) => (
            <span
              key={`Ticket-${index}`}
              className={currentTicket === index ? "active" : ""}
            ></span>
          ))}
        </div>
      </div>
      <button
        className="ticketSelector_btn next"
        onClick={() => nextTicket()}
        disabled={currentTicket + 1 >= totalTickets}
      ></button>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    GAMEPLAY: state.game.GAMEPLAY,
    STATUS_DATA: state.game.STATUS_DATA,
  };
};

export default connect(mapStateToProps, {})(TicketSelector);
